import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0198b984"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "table table-tenant" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "MT", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "fa-solid fa-vial text-danger m-1"
}
const _hoisted_11 = {
  key: 1,
  class: "fa-regular fa-file text-primary m-1"
}
const _hoisted_12 = ["title"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "d-flex align-items-center gap-1" }
const _hoisted_17 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_18 = {
  key: 1,
  class: "fa-solid fa-circle-dot text-danger"
}
const _hoisted_19 = { class: "d-flex justify-content-start align-items-center gap-2" }
const _hoisted_20 = { class: "me-1" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}

import { ref, onMounted, inject, provide } from "vue";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import { CommentType } from "@/core/types/CommentType";
import { AccountRoleTypes } from "@/core/types/AccountInfos";
import TinyCopyBox from "@/components/TinyCopyBox.vue";
import CommentsView from "@/projects/tenant/components/CommentView.vue";
import { Avatar, WarningFilled } from "@element-plus/icons-vue";
import ViewReferPath from "@/projects/tenant/modules/accounts/components/modal/ViewReferPath.vue";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import { ArrowDown } from "@element-plus/icons-vue";
import InjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import AccountDetail from "../components/AccountDetail.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AutoCreateAccounts',
  setup(__props) {

const paymentService = ref(Array<any>());
const isLoading = ref(false);
const data = ref<any[]>([]);
const commentsRef = ref<any>(null);
const tab = ref("unconfimredAccount");
const accountSelected = ref(0);
const accountDetailRef = ref<InstanceType<typeof AccountDetail>>();
const criteria = ref<any>({
  page: 1,
  size: 20,
  sortField: "CreatedOn",
  tagName: "AutoCreate",
});

const openConfirmModal = inject<any>(
  TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL
);

const showAccountDetail = (id: number, _tab = "infos") => {
  accountDetailRef.value.show(id, _tab, paymentService.value);
};

const handleOpenUserDetail =
  inject(InjectionKeys.OPEN_USER_DETAILS) ?? (() => null);

provide(AccountInjectionKeys.HANDLE_REFRESH_ACCOUNT_CLIENT_TABLE, () =>
  fetchData(criteria.value.page)
);

const tabClicked = async () => {
  if (tab.value === "unconfimredAccount") {
    criteria.value.tagName = "AutoCreate";
  } else {
    criteria.value.tagName = "AutoCreateConfirmed";
  }
  await fetchData(1);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  try {
    const response = await AccountService.queryAccounts(criteria.value);
    criteria.value = response.criteria;
    data.value = response.data;
  } catch (error) {
    console.error(error);
  }

  isLoading.value = false;
};

const showConfirmModal = (item: any) => {
  openConfirmModal?.(() =>
    AccountService.confirmAutoCreateAccount(item.id).then(() => fetchData(1))
  );
};

const handleGodModeClick = UserService.generateGodModeHandler();

const viewComments = (type: CommentType, id: number, title: string) => {
  commentsRef.value?.show(type, id, title);
};

const selectedAccount = (id: number) => {
  accountSelected.value = id;
};

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_AccountStatusBadge = _resolveComponent("AccountStatusBadge")!
  const _component_TimeShow = _resolveComponent("TimeShow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_tabs, {
      modelValue: tab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (tabClicked()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: _ctx.$t('fields.unconfimredAccount'),
          name: "unconfimredAccount",
          disabled: isLoading.value
        }, null, 8, ["label", "disabled"]),
        _createVNode(_component_el_tab_pane, {
          label: _ctx.$t('fields.confimredAccount'),
          name: "confimredAccount",
          disabled: isLoading.value
        }, null, 8, ["label", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.id")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.type")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.currency")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.wallet") + " ID"), 1),
              _hoisted_4,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.tradeAccount")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.name")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.email")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.site")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.group")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.role")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.sales")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.ib")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.created_at")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass({
              'text-gray-600': item.status === 1,
              'text-gray-400': item.status === 2,
              'account-select': item.id === accountSelected.value,
            }),
                      onClick: ($event: any) => (selectedAccount(item.id))
                    }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_dropdown, null, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                (tab.value == 'unconfimredAccount')
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 0,
                                      onClick: ($event: any) => (showConfirmModal(item))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("action.confirm")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_dropdown_item, {
                                  divided: "",
                                  onClick: ($event: any) => (_unref(handleOpenUserDetail)(item.user?.partyId))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("title.userDetails")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_el_dropdown_item, {
                                  divided: "",
                                  onClick: ($event: any) => (showAccountDetail(item.id, 'infos'))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("title.accountDetails")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              plain: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.action")), 1),
                                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ArrowDown))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("td", {
                        onClick: ($event: any) => (_unref(handleGodModeClick)(item.partyId))
                      }, [
                        _createVNode(_component_AccountStatusBadge, {
                          status: item.status,
                          showDot: true
                        }, null, 8, ["status"]),
                        (item.accountTags.includes('Test'))
                          ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                          : _createCommentVNode("", true),
                        (item.accountTags.includes('DailyConfirmEmail'))
                          ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_9),
                      _createElementVNode("td", {
                        title: `${item.id} (${item.partyId})`
                      }, [
                        _createTextVNode(_toDisplayString(item.uid), 1),
                        _createVNode(TinyCopyBox, {
                          class: "p-1",
                          val: item.uid.toString()
                        }, null, 8, ["val"])
                      ], 8, _hoisted_12),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.shortAccount.${item.type}`)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.currency.${item.currencyId}`)), 1),
                      _createElementVNode("td", null, _toDisplayString(item.walletId), 1),
                      _createElementVNode("td", null, _toDisplayString(item.tradeAccount.serviceName), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          role: "button",
                          onClick: ($event: any) => (
                  viewComments(_unref(CommentType).Account, item.id, item.accountNumber)
                )
                        }, [
                          _createTextVNode(_toDisplayString(item.accountNumber) + " ", 1),
                          (item.hasComment)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_13),
                        (item.accountNumber)
                          ? (_openBlock(), _createBlock(TinyCopyBox, {
                              key: 0,
                              val: item.accountNumber.toString()
                            }, null, 8, ["val"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          role: "button",
                          onClick: ($event: any) => (
                  viewComments(
                    _unref(CommentType).User,
                    item.user.partyId,
                    item.user.firstName + ' ' + item.user.lastName
                  )
                )
                        }, [
                          _createElementVNode("div", _hoisted_16, [
                            _createTextVNode(_toDisplayString(item.user.firstName) + " " + _toDisplayString(item.user.lastName) + " ", 1),
                            (item.user.hasComment)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                              : _createCommentVNode("", true),
                            (item.user.status == 2)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                              : _createCommentVNode("", true),
                            (item.isInIpBlackList)
                              ? (_openBlock(), _createBlock(_component_el_icon, {
                                  key: 2,
                                  color: "#FF0000"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(WarningFilled))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (item.isInUserBlackList)
                              ? (_openBlock(), _createBlock(_component_el_icon, { key: 3 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Avatar))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ], 8, _hoisted_15)
                      ]),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(item.user.email), 1),
                        _createVNode(TinyCopyBox, {
                          class: "p-1",
                          val: item.user.email
                        }, null, 8, ["val"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.siteType.${item.siteId}`)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(ViewReferPath, {
                            item: item,
                            paymentService: paymentService.value
                          }, null, 8, ["item", "paymentService"]),
                          _createElementVNode("div", null, _toDisplayString(item.group), 1)
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.accountRole.${item.role}`)), 1),
                      _createElementVNode("td", null, [
                        (item.role === _unref(AccountRoleTypes).Sales)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("span", _hoisted_20, _toDisplayString(item.code), 1),
                              _createVNode(TinyCopyBox, {
                                val: item.code.toString()
                              }, null, 8, ["val"])
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                              _createElementVNode("span", {
                                role: "button",
                                onClick: ($event: any) => (
                    viewComments(
                      _unref(CommentType).Account,
                      item.salesAccount.id,
                      item.salesAccount.user.firstName +
                        ' ' +
                        item.salesAccount.user.lastName
                    )
                  )
                              }, [
                                _createTextVNode(" [" + _toDisplayString(item.salesAccount.code) + "] " + _toDisplayString(item.salesAccount.uid) + " ", 1),
                                (item.salesAccount.hasComment)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_22),
                              _createVNode(TinyCopyBox, {
                                val: item.salesAccount.uid.toString()
                              }, null, 8, ["val"])
                            ]))
                      ]),
                      _createElementVNode("td", null, [
                        (item.agentAccount.id == 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "No IB"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_25, [
                              _createElementVNode("span", {
                                role: "button",
                                onClick: ($event: any) => (
                    viewComments(
                      _unref(CommentType).Account,
                      item.agentAccount.id,
                      item.agentAccount.user.firstName +
                        ' ' +
                        item.agentAccount.user.lastName
                    )
                  )
                              }, [
                                _createTextVNode("[" + _toDisplayString(item.agentAccount.group) + "] " + _toDisplayString(item.agentAccount.uid) + " ", 1),
                                (item.agentAccount.hasComment)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_27))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_26),
                              _createVNode(TinyCopyBox, {
                                val: item.agentAccount.uid.toString()
                              }, null, 8, ["val"])
                            ]))
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ])
                    ], 10, _hoisted_8))
                  }), 128))
                ]))
        ])
      ]),
      _createVNode(CommentsView, {
        ref_key: "commentsRef",
        ref: commentsRef,
        type: "",
        id: "0"
      }, null, 512),
      _createVNode(AccountDetail, {
        ref_key: "accountDetailRef",
        ref: accountDetailRef
      }, null, 512)
    ])
  ], 64))
}
}

})